import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  FR: {
    translation: {
      navbar: {
        home: "Accueil",
        about: "Mon parcours",
        news: "Actualités",
        prestations: "Prestations",
        priseRDV: "Prise de RDV",
        contact: "Contact",
        search: "Rechercher...",
        admin: "Administrateur",
      },
      testimonials: {
        title: "Témoignages",
        subtitle: "Retours d'expériences",
        previous: "Précédent",
        next: "Suivant",
        fullscreen: "Plein écran",
        close: "Fermer",
      },
      news: {
        titleUnavailable: "Titre non disponible",
        contentUnavailable: "Contenu non disponible",
        loading: "Chargement des actualités...",
        date: "Date",
        readMore: "Lire la suite",
        close: "Fermer",
      },
      homepage: {
        lastnews: "Dernières actualités",
        button: "Découvrir toutes mes actualités",
        lastgalleries: "Derniers albums photos",
        buttonLastGalleries: "Découvrir tous mes albums photos",
      },
      footer: {
        madeBy: "Site réalisé par Laurent VICTORIN",
        legalTitle: "Mentions légales",
        hostingTitle: "Hébergeur",
        hostingContent: "Hostinger",
        designTitle: "Crédits & design",
        cgv: "Conditions Générales de Vente",
        rights: "Tous droits réservés",
        phone: "Téléphone",
      },
      partnerBanner: {
        legende: "Pascaline - judokate passionnée",
        partner: "Secrets de Judokas",
        contact: "Pascaline Magnes",
        title: "Entraîne-toi intelligemment & progresse rapidement",
        content:
          "Applique des méthodes précises et éprouvées pour atteindre tes objectifs judo.",
        button: "Découvrir Secrets de Judokas",
      },
    },
  },
  EN: {
    translation: {
      navbar: {
        home: "Home",
        about: "My Journey",
        news: "News",
        prestations: "Prestations",
        priseRDV: "Book an Appointment",
        contact: "Contact",
        search: "Search...",
        admin: "Administrator",
      },
      testimonials: {
        title: "Testimonials",
        subtitle: "Feedback",
        previous: "Previous",
        next: "Next",
        fullscreen: "Full screen",
        close: "Close",
      },
      news: {
        titleUnavailable: "Title unavailable",
        contentUnavailable: "Content unavailable",
        loading: "Loading news...",
        date: "Date",
        readMore: "Read more",
        close: "Close",
      },
      homepage: {
        lastnews: "Last news",
        button: "Discover all my news",
        lastgalleries: "Last photo galleries",
        buttonLastGalleries: "Discover all my photo galleries",
      },
      footer: {
        madeBy: "Website by Laurent VICTORIN",
        legalTitle: "Legal notice",
        hostingTitle: "Hosting provider",
        hostingContent: "Hostinger",
        designTitle: "Credits & design",
        cgv: "Terms & Conditions",
        rights: "All rights reserved",
        phone: "Phone",
      },
      partnerBanner: {
        legende: "Pascaline - passionate judoka",
        partner: "Secrets de Judokas",
        contact: "Pascaline Magnes",
        title: "Train smart & progress quickly",
        content: "Apply precise and proven methods to achieve your judo goals.",
        button: "Discover Secrets de Judokas",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "FR", // Langue par défaut
  fallbackLng: "FR", // Langue utilisée si la traduction n'est pas disponible
  interpolation: {
    escapeValue: false, // React échappe déjà par défaut
  },
});

export default i18n;
